import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DevPasscodeModal from "../DevPasscodeModal/DevPasscodeModal";
import { hasDevAccess } from "../../utils/devPasscode";

interface DevProtectedRouteProps {
  children: React.ReactNode;
}

const DevProtectedRoute: React.FC<DevProtectedRouteProps> = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(() => hasDevAccess());

  if (isAuthorized) {
    return <>{children}</>;
  }

  return (
    <DevPasscodeModal
      isOpen={true}
      onSuccess={() => setIsAuthorized(true)}
      onCancel={() => navigate("/main")}
    />
  );
};

export default DevProtectedRoute;
